'use client'

import DocPage from './DocPage'

export default function Delivery({ vendor }: { vendor?: any }) {
  return (
    <DocPage
      vendor={vendor}
      pageKey="delivery"
      title="Хүргэлтийн нөхцөл"
      description="Захиалга хүлээн авах хугацаа, бүс нутаг, хүргэлттэй холбоотой нөхцөлүүдийг доороос уншина уу."
      htmlContent={vendor?.terms?.delivery}
      emptyMessage="Одоогоор хүргэлтийн нөхцөл нэмэгдээгүй байна."
    />
  )
}
